import { z } from 'zod'

import { useTranslations } from '../translate'

export const useValidate = (
  schema: z.ZodTypeAny | undefined,
  required: boolean | undefined,
  value: unknown,
) => {
  const t = useTranslations()

  const parsed = schema?.safeParse(value)

  if (!parsed || parsed.success) {
    if (!required) {
      return
    }

    if ((Array.isArray(value) && value.length) || value === 0 || value) {
      return
    }

    return t.form.required()
  }

  return parsed?.error.issues[0].message ?? t.form.invalid_value()
}
